var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "message-audio",
    class: [_vm.isMobile && 'message-audio-h5', _vm.message.flow === 'out' && 'reserve', _vm.message.hasRiskContent && 'disable'],
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return _vm.play.apply(null, arguments);
      }
    }
  }, [_c('div', {
    staticClass: "audio-icon-container"
  }, [_c('Icon', {
    class: {
      icon: true,
      play: _vm.isAudioPlaying
    },
    attrs: {
      "width": "16px",
      "height": "16px",
      "file": _vm.currentAudioIcon
    }
  })], 1), _c('span', {
    staticClass: "time",
    style: {
      width: ((_vm.data.second * 2 + 20) + "px")
    }
  }, [_vm._v(" " + _vm._s(_vm.data.second || 1) + "\" ")]), _c('audio', {
    ref: "audioRef",
    attrs: {
      "src": _vm.audioUrl
    }
  })]);
}
var staticRenderFns = []

export { render, staticRenderFns }